var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{opacity:0.5;isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    className: "cls-1",
    d: "M17.58,32H14.41A1.53,1.53,0,0,1,13,30.89l-1.43-4.12-3.8,1.9a1.73,1.73,0,0,1-1.9-.31L3.64,26.14a1.7,1.7,0,0,1-.32-1.9l1.91-3.81L1.11,19A1.53,1.53,0,0,1,0,17.58V14.41A1.53,1.53,0,0,1,1.11,13l4.12-1.43-1.9-3.8a1.67,1.67,0,0,1,.31-1.9L5.86,3.64a1.7,1.7,0,0,1,1.9-.32l3.81,1.91L13,1.11A1.53,1.53,0,0,1,14.41,0h3.17A1.53,1.53,0,0,1,19,1.11l1.43,4.12,3.8-1.9a1.67,1.67,0,0,1,1.9.31l2.22,2.22a1.7,1.7,0,0,1,.32,1.9l-1.91,3.8L30.89,13A1.53,1.53,0,0,1,32,14.42v3.17A1.53,1.53,0,0,1,30.89,19l-4.12,1.43,1.9,3.8a1.67,1.67,0,0,1-.31,1.9l-2.22,2.22a1.7,1.7,0,0,1-1.9.32l-3.8-1.91L19,30.89A1.53,1.53,0,0,1,17.58,32Zm-2.06-3.17h.95l1.43-4.28a2.18,2.18,0,0,1,2.69-1.11l4.12,2.07.63-.63-2.06-4.13a2.11,2.11,0,0,1,1.11-2.68l4.28-1.43v-1l-4.28-1.42a2.18,2.18,0,0,1-1.11-2.69l2.06-4.12-.63-.64L20.59,8.86a2.09,2.09,0,0,1-2.68-1.11L16.47,3.49h-.95L14.1,7.76a2.16,2.16,0,0,1-2.69,1.11L7.29,6.81l-.64.63,2.06,4.12A2.11,2.11,0,0,1,7.6,14.25L3.33,15.68v.95L7.6,18.05a2.16,2.16,0,0,1,1.11,2.69L6.65,24.87l.64.63,4.12-2.06a2.11,2.11,0,0,1,2.68,1.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_404",
    "data-name": "Ellipse 404",
    className: "cls-2",
    cx: 16,
    cy: 16.15,
    r: 3.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.4ebbdd861c58dc8ba2e7664f70bf01ed.svg";
export { ForwardRef as ReactComponent };